export const SHARE_AND_TRENDS_FILTERED = 'Share & Trends Filtered'
